import { FC } from 'react';

import { Contact } from '@payaca/types/contactTypes';

import UntitledIcon from '@payaca/untitled-icons';
import './ContactDetailInfo.sass';

type Props = {
  contact: Partial<Contact>;
};
const ContactDetailInfo: FC<Props> = ({ contact }: Props) => {
  return (
    <div className="contact-detail-info">
      {contact?.name && (
        <div className="contact-name-wrapper">
          <UntitledIcon name="user-circle.3" />
          <span className="contact-detail-name">{contact?.name}</span>
        </div>
      )}
      {contact?.emailAddress && (
        <a href={`mailto:${contact?.emailAddress}`} className="contact-method">
          <UntitledIcon name="message-text-square-01.3" />
          <span>{contact?.emailAddress}</span>
        </a>
      )}
      {contact?.telephoneNumber && (
        <a href={`tel:${contact?.telephoneNumber}`} className="contact-method">
          <UntitledIcon name="phone.3" />
          <span>{contact?.telephoneNumber}</span>
        </a>
      )}
      {contact?.description && (
        <div className="contact-notes">
          <UntitledIcon name="passcode-lock.3" />
          <span>{contact.description}</span>
        </div>
      )}
    </div>
  );
};

export default ContactDetailInfo;
